/**
 * @file use-navigation.js
 * @description Wrapper de useNavigate (React Router). Sem overlay global — loading de rota
 * fica a cargo de Suspense / useLoading local quando necessário.
 */

import { useNavigate } from "react-router-dom"

/**
 * Normaliza assinatura legada: (url, message?, options?) → options do navigate.
 * O 2º arg string (mensagem) é ignorado (nunca foi lido por overlays).
 * @param {unknown} messageOrOptions
 * @param {object} [options]
 * @returns {object}
 */
function resolveNavigateOptions(messageOrOptions, options = {}) {
  if (
    typeof messageOrOptions === "object" &&
    messageOrOptions !== null &&
    !Array.isArray(messageOrOptions)
  ) {
    return messageOrOptions
  }
  return options
}

/**
 * Hook para navegação SPA
 * @returns {{ navigateWithLoading: Function, replaceWithLoading: Function, navigate: Function }}
 */
export function useNavigation() {
  const navigate = useNavigate()

  const navigateWithLoading = (url, messageOrOptions, options = {}) => {
    navigate(url, resolveNavigateOptions(messageOrOptions, options))
  }

  const replaceWithLoading = (url, messageOrOptions, options = {}) => {
    navigate(url, {
      ...resolveNavigateOptions(messageOrOptions, options),
      replace: true,
    })
  }

  return {
    navigateWithLoading,
    replaceWithLoading,
    navigate: navigateWithLoading,
  }
}
